import React from 'react';
import { palette } from '../../design-system/colors';
import { FlexDiv } from '../../design-system/containers';
import { primaryColor } from '../../../utils/helpers';

export default function DecisionPlayerProgressbar({
    totalLength = 1,
    counter,
}) {
    return (
        <FlexDiv fullWidth backgroundColor={palette.graphite.heavyMetal} height={10}>
            <FlexDiv
                widthPercentage={((counter / totalLength) * 100) / 0.95} //Dividing by 0.95 because we stop video at 95% to ask user to make a decision
                backgroundColor={primaryColor}
                fullHeight
            />
        </FlexDiv>
    );
}
